import { cva, VariantProps } from 'class-variance-authority';

export const textarea = cva(
  [
    'outline-0',
    'text-base',
    'font-medium',
    'w-full',
    'border-solid',
    'border',
    'border-neutral-700',
  ],
  {
    variants: {
      disabled: {
        true: ['text-neutral-500', 'bg-transparent', 'border-neutral-400'],
        false: ['text-inherit', 'border-neutral-700'],
      },
    },
  }
);

export const inputWrapper = cva(['peer', 'flex-1', 'pt-5']);

export const label = cva(['peer', 'w-full']);

export type StyleProps = VariantProps<typeof textarea>;
